module.exports = __webpack_public_path__ + "img/Apoptosis-PDAC_GSE205354.20b01118.png";